import errorReporter from '@app/errorReporter';
import { Flex } from '@bb/elements-web';
import { TrrebApiReason } from '@bb/users';
import { Button, message } from 'components';
import { AuthContext } from 'contexts';
import React, { useContext } from 'react';
import type { IUserSearchDetailsResponse } from '@/app-package';
import { searchDetails } from '../../../../api/UserController';
import AppointmentBookingInternalContext from '../AppointmentBookingInternalContext';
import CoopDetails from './CoopDetails';
import VirtualTabContext from './VirtualTabContext';
import VirtualRosterInput, { AgentUserResult } from './VirtualRosterInput';

const VirtualCoopSelectStep: React.FC = () => {
  const { auth } = useContext(AuthContext);
  const { listing } = useContext(AppointmentBookingInternalContext);
  const { bookFor, bookForOptions, setBookFor, setCoop } =
    useContext(VirtualTabContext);
  const isSelf = bookFor === 'self';

  const handleSelectUser = async (user: AgentUserResult) => {
    try {
      const foundUser: IUserSearchDetailsResponse & {
        uid?: string;
        mlsType?: string;
      } = await searchDetails({
        ...user,
        reason: TrrebApiReason.ViewingPreSale,
        listingId: listing!.id,
      });
      foundUser.uid ||= user.uid;
      foundUser.mlsType ||= user.mlsType;
      setCoop({
        uid: foundUser.uid,
        ...('id' in foundUser && { id: foundUser.id }),
        email: foundUser.emails?.[0] || foundUser.email || '',
        name: `${foundUser.firstName} ${foundUser.lastName}`,
        firstName: foundUser.firstName,
        lastName: foundUser.lastName,
        board: foundUser.board || '',
        boardId: foundUser.boardId,
        mls: foundUser.mlsType,
        phone: foundUser[user.id ? 'phone' : 'lastPhone'] || '',
        org: {
          address: foundUser.org.address,
          name: foundUser.org.name || '',
          phone: foundUser.org.phone || '',
        },
      });
    } catch (err) {
      errorReporter.error(err);
      message.error('Error selecting agent');
    }
  };

  return (
    <>
      {bookForOptions.length === 2 && (
        <Flex justify="space-around">
          <Button
            type={isSelf ? 'primary' : 'default'}
            onClick={() => setBookFor('self')}
            data-cy="bookFor-self-btn"
          >
            Book For Myself
          </Button>
          <Button
            type={!isSelf ? 'primary' : 'default'}
            onClick={() => setBookFor('others')}
            data-cy="bookFor-otherAgent-btn"
          >
            Book For Another Agent
          </Button>
        </Flex>
      )}
      {!isSelf && (
        <VirtualRosterInput
          auth={auth}
          listingId={listing!.id}
          selectUser={handleSelectUser}
          deselectUser={() => setCoop(null)}
        />
      )}
      <CoopDetails />
    </>
  );
};

export default VirtualCoopSelectStep;
